// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const toxtricity: PokeData = {
  id: 849,
  name: "toxtricity",
  height: 16,
  weight: 400,
  base_experience: 176,
  types: [PokeType.ELECTRIC, PokeType.POISON],
  api_moves: [
    "leer",
    "growl",
    "acid",
    "thunder-shock",
    "toxic",
    "screech",
    "flail",
    "scary-face",
    "swagger",
    "spark",
    "charge",
    "taunt",
    "shock-wave",
    "poison-jab",
    "discharge",
    "venoshock",
    "acid-spray",
    "shift-gear",
    "belch",
    "noble-roar",
    "boomburst",
    "eerie-impulse",
    "nuzzle",
    "tearful-look",
    "overdrive",
  ],
  moves: [
    "leer",
    "growl",
    "acid",
    "thunder-shock",
    "scary-face",
    "poison-jab",
    "thunder-punch",
    "sludge-bomb",
    "wild-charge",
    "toxic-overload",
    "electric-wrath",
    "mortal-gas",
    "volt-switch",
  ],
  evolution_chain: {
    id: 446,
    item: null,
    species: [
      {
        name: "toxel",
        order: 848,
        types: [PokeType.ELECTRIC, PokeType.POISON],
        evolves_from_species_id: null,
        pokemonevolutions: [],
      },
      {
        name: "toxtricity",
        order: 849,
        types: [PokeType.ELECTRIC, PokeType.POISON],
        evolves_from_species_id: 848,
        pokemonevolutions: [
          {
            type: null,
            min_level: 30,
            item: null,
            location: null,
            min_happiness: null,
            min_affection: null,
            min_beauty: null,
            move: null,
            relative_physical_stats: null,
            time_of_day: "",
            trade_species_id: null,
            turn_upside_down: false,
            held_item_name: null,
            evolutiontrigger: {
              name: EvolutionTriggerName.LEVEL_UP,
            },
            gender: null,
          },
        ],
      },
    ],
  },
  stats: {
    resistance: 113,
    speed: 119,
    ability_power: 168,
  },
  stat_changes: [],
  catch_rate: 45,
  is_legendary: false,
  is_mythical: false,
  is_mega: false,
  is_gmax: false,
  regional_variant: null,
} as const;
